<script>
  import PlayerList from './PlayerList.svelte';
  import { onDestroy, onMount, createEventDispatcher } from "svelte";
  import Crossword from "svelte-crossword";

  //
  export let id;
  export let playerToken;
  export let players;
  export let puzzle;
  export let answers;

  const dispatch = createEventDispatcher();

  let previousCellIndex = null;
  let previousCellValue = null;
  let previousDirection = null;

  // cells is the internal data structure ofthe svelte-crossword
  // component, and contains both the puzzle and answers. It is
  // populated via a data-binding on mount. Not simple, but easy.
  $: cells = null;
  $: focusedDirection = null;
  $: focusedCellIndex = null;

  let self = null;
  let otherPlayers = [];
  
  let subscriptions = [];
  onDestroy(() => {
    subscriptions.forEach((e) => e.unsubscribe());
  });

  onMount(() => {
    // When props of this component change, update the cells array
    // with answers from the server.
    subscriptions.push(
      answers.subscribe((newAnswers) => {
        if (newAnswers) {
          cells =
          cells &&
          cells.map((cell, i) => {
            if (newAnswers[i] !== null && newAnswers[i] !== cell.value) {
              cell.value = newAnswers[i];
            }
            return cell;
          });
        };
      })
    );

    // @TODO fix
    self = players[playerToken];
    otherPlayers = Object.values(players).filter(p => p.id !== playerToken);
    subscriptions.push(
      players.subscribe((players) => {
        self = players[playerToken];
        otherPlayers = Object.values(players).filter(p => p.id !== playerToken);
      })
    );
  });

  $: if (cells) {
    const focused = focusedCellIndex !== null ? cells[focusedCellIndex] : null;
    const previouslyOccupiedCell =
      previousCellIndex !== null ? cells[previousCellIndex] : null;
      
    const didChangePosition = previouslyOccupiedCell && previouslyOccupiedCell.index !== focusedCellIndex;
    const didChangeValue = previouslyOccupiedCell && (previouslyOccupiedCell.value !== previousCellValue);
    const didChangeDirection = previousDirection && previousDirection !== focusedDirection;

    const position = {
      index: focusedCellIndex,
      direction: focusedDirection,
    };

    if (didChangeValue) {
      dispatch("value", {
        index: previouslyOccupiedCell.index,
        value: previouslyOccupiedCell.value,
        position,
      });
    } else if (didChangePosition || didChangeDirection) {
      dispatch("move", position);
    }

    previousCellIndex = focusedCellIndex;
    previousCellValue = focused ? focused.value : null;
    previousDirection = focusedDirection;
  }
</script>

<div class="container">
  <Crossword
    bind:cells
    bind:focusedDirection
    bind:focusedCellIndex
    {otherPlayers}
    data={$puzzle}
  >
  <div slot="toolbar-top">
    <PlayerList {self} {otherPlayers} />
  </div>
</Crossword>
</div>
